import type { RouteRecordRaw } from 'vue-router';
import { menuToRoutes, eachTree } from '../utils';
import type { MenuItem } from '../api';
import {
  LOGIN_PATH,
  HOME_PATH,
  LAYOUT_PATH,
  REDIRECT_PATH,
  WHITE_LIST
} from '../config/setting';
import RedirectLayout from '@/components/RedirectLayout/index.vue';
import MainLayout from '@/layouts/index.vue';
// 修改为匹配所有 .vue 文件
const modules = import.meta.glob('/src/views/**/*.vue');

/**
 * 静态路由
 */
export const routes: RouteRecordRaw[] = [
  {
    path: LOGIN_PATH,
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  // 404
  {
    path: '/:path(.*)*',
    component: () => import('@/views/error/404.vue')
  }
];

/**
 * 根据菜单生成动态路由
 * @param menus 菜单数据
 */
export function getMenuRoutes(menus?: MenuItem[]) {
  // 需要布局的子路由
  const childRoutes: RouteRecordRaw[] = [
    // 用于刷新的路由
    {
      path: REDIRECT_PATH + '/:path(.*)',
      component: RedirectLayout,
      meta: { hideFooter: true }
    }
  ];
  // 不需要布局的路由
  const withoutLayoutRoutes: RouteRecordRaw[] = [];
  // 将菜单转换为路由
  const menuRoutes = menuToRoutes(menus || [], getComponent);
  // 路由铺平处理
  if (menuRoutes && menuRoutes.length > 0) {
    // 递归处理所有路由
    const processRouteTree = (routes: RouteRecordRaw[]) => {
      routes.forEach(route => {
        // 创建临时路由对象（移除children）
        const temp = { ...route, children: undefined };
        // 检查组件
        if (!temp.component && !temp.redirect) temp.component = () => import('@/views/error/404.vue');
        // 根据 layout 配置分类
        if (temp.meta?.layout === false) withoutLayoutRoutes.push(temp);
        else childRoutes.push(temp);
        // 递归处理子路由
        if (route.children && route.children.length > 0) processRouteTree(route.children);
      });
    };
    processRouteTree(menuRoutes);
  }
  // 构建最终的路由配置
  const layoutRoutes: RouteRecordRaw[] = [
    {
      path: '/',
      redirect:LOGIN_PATH
    },
    {
      path: '/layout',
      name: 'Layout',
      component: MainLayout,
      meta: {
        title: '首页' ,
      },
      children: childRoutes
    },
    ...withoutLayoutRoutes
  ];
  return layoutRoutes;
}

/**
 * 判断是否是白名单路由
 * @param path 路由地址
 */
export function isWhiteList(path: string) {
  if (!path) return false;
  return WHITE_LIST.some((whitePath) => {
    if (whitePath === path) return true;
    if (whitePath.endsWith('*') && path.startsWith(whitePath.slice(0, -1))) return true;
    return false;
  });
}

/**
 * 解析路由组件
 * @param component 组件名称
 */
function getComponent(component?: string) {
  if (!component) return;
  // 尝试匹配组件路径
  const possiblePaths = [
    `/src/views${component}.vue`,
    `/src/views${component}/index.vue`
  ];
  for (const path of possiblePaths) {
    const module = modules[path];
    if (module) return module;
  }
  return () => import('@/views/error/404.vue');
}
